import { API_ROOT } from 'environment';

angular.module('app.resources').factory('ActivationCodes', ($q, $resource) =>
    $resource(`${API_ROOT}/activations/:id`, { id: '@id' }, {
        getSafe: {
          method: 'GET',
          'Interceptor-Ignore-Errors': true,
        },
        create: {
            method: 'POST',
            url: `${API_ROOT}/activations`,
            isArray: true
        },
        update: {
            method: 'PUT',
            url: `${API_ROOT}/activations/:id`
        },
        list: {
            method: 'GET',
            url: `${API_ROOT}/activations`,
            isArray: true
        },
        queryAccount: {
            method: 'GET',
            url: `${API_ROOT}/accounts/:account_id/activations`,
            isArray: true
        }
    })
);



// WEBPACK FOOTER //
// ./resources/activation_codes.js